import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/no-did-update-set-state */

/* eslint-disable react/static-property-placement */

/* eslint-disable react/sort-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ErrorBoundary, Spinner, Tooltip } from '@sainsburys-tech/bolt';
import { WishlistIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './Button.styles';
import { addLocalItems, removeLocalItems } from '../../redux/localList/updateItems';
import { addGlobalItems, removeGlobalItems } from '../../redux/globalList/updateItems';

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "prefixer", function (prefix) {
      return prefix !== null ? "".concat(prefix, "-") : '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function () {
      var _this$props = _this.props,
          item = _this$props.item,
          isChecked = _this$props.isChecked,
          onUpdate = _this$props.onUpdate,
          userState = _this$props.userState;
      var isLoggedIn = userState === 'LOGGEDIN';
      var addItems = isLoggedIn ? _this.props.addGlobalItems : _this.props.addLocalItems;
      var removeItems = isLoggedIn ? _this.props.removeGlobalItems : _this.props.removeLocalItems;

      if (!_this.state.isLoading) {
        if (isLoggedIn) {
          _this.setState({
            isLoading: true,
            wasChecked: !!isChecked
          });
        }

        if (isChecked) {
          removeItems([item]);
        } else {
          addItems([item]);
        }

        onUpdate(!isChecked);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoginRedirect", function () {
      if (global.document) {
        var redirectCookieName = 'LastUrlCookie';
        var redirectCookiePath = "https://".concat(global.document.location.host, "/wishlist/");
        global.document.cookie = "".concat(redirectCookieName, "=").concat(redirectCookiePath, "; path=/");
      }
    });

    _this.state = {
      isLoading: false,
      wasChecked: !!_this.props.isChecked
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isChecked = !!this.props.isChecked;
      var shouldStopLoading = prevState.isLoading && (isChecked !== prevState.wasChecked || this.props.globalError);

      if (shouldStopLoading) {
        this.setState({
          isLoading: false,
          wasChecked: isChecked
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          isChecked = _this$props2.isChecked,
          userState = _this$props2.userState,
          localListSize = _this$props2.localListSize,
          showMessage = _this$props2.showMessage,
          messageData = _this$props2.messageData,
          onChange = _this$props2.onChange,
          tooltipWidth = _this$props2.tooltipWidth,
          tooltipDurationToShow = _this$props2.tooltipDurationToShow,
          tooltipPosition = _this$props2.tooltipPosition,
          tooltipDirection = _this$props2.tooltipDirection,
          tooltipMobileDirection = _this$props2.tooltipMobileDirection,
          dataTest = _this$props2['data-test'],
          placement = _this$props2.placement;
      var isLoading = this.state.isLoading;
      var visible = showMessage ? '' : 'sr-only';
      var isItemChecked = !!isChecked;
      var isLoggedIn = userState === 'LOGGEDIN';
      var hasTooltipAlreadyShown = localListSize > 0;
      var messageText = isChecked ? messageData[0] : messageData[1];
      var toolTipContent = /*#__PURE__*/React.createElement("div", {
        className: "ac-tooltip__wishlist"
      }, /*#__PURE__*/React.createElement(WishlistIcon, {
        width: "8em",
        height: "3.5em",
        fill: "#d42114",
        filled: true
      }), /*#__PURE__*/React.createElement("p", {
        className: "font-standard"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/account/login",
        onClick: this.handleLoginRedirect
      }, "Sign in or register"), ' ', "to save items to your account. Simply tap the heart again to remove."));
      var tooltipOptions = {
        content: toolTipContent,
        width: tooltipWidth,
        durationToShow: tooltipDurationToShow,
        position: tooltipPosition,
        direction: tooltipDirection,
        mobileDirection: tooltipMobileDirection,
        enabled: !(isItemChecked || isLoggedIn || isLoading || hasTooltipAlreadyShown)
      };
      var labelStyle = {
        display: 'flex',
        alignItems: 'center'
      };
      var messageStyle = {
        paddingLeft: '10px'
      };
      return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
        className: "wishlist-checkbox",
        "data-test": dataTest
      }, /*#__PURE__*/React.createElement(Tooltip, _extends({}, tooltipOptions, {
        "data-test": "".concat(dataTest, "-tooltip")
      }), /*#__PURE__*/React.createElement(Styled.Input, {
        "aria-label": messageText,
        type: "checkbox",
        id: "".concat(this.prefixer(placement), "wishlist-item-").concat(item.partNumber),
        className: "wishlist-checkbox__input",
        checked: isChecked,
        onChange: onChange,
        "data-test": "".concat(dataTest, "-checkbox-input"),
        tabIndex: "-1"
      }), /*#__PURE__*/React.createElement(Styled.Button, {
        htmlFor: "".concat(this.prefixer(placement), "wishlist-item-").concat(item.partNumber),
        className: "wishlist-checkbox__label",
        onClick: this.handleToggle,
        style: labelStyle,
        type: "button"
      }, isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        size: 24,
        style: {
          position: 'initial'
        }
      }) : /*#__PURE__*/React.createElement(WishlistIcon, {
        className: "wishlist-checkbox__icon",
        fill: "#d42114",
        width: "24px",
        height: "24px",
        filled: isChecked
      }), /*#__PURE__*/React.createElement("div", {
        className: visible,
        style: messageStyle
      }, /*#__PURE__*/React.createElement(Styled.Span, null, messageText))))));
    }
  }]);

  return Button;
}(React.Component);

_defineProperty(Button, "propTypes", {
  item: PropTypes.shape().isRequired,
  addLocalItems: PropTypes.func.isRequired,
  removeLocalItems: PropTypes.func.isRequired,
  addGlobalItems: PropTypes.func.isRequired,
  removeGlobalItems: PropTypes.func.isRequired,
  showMessage: PropTypes.bool.isRequired,
  messageData: PropTypes.arrayOf(PropTypes.string),
  onUpdate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  userState: PropTypes.string.isRequired,
  globalError: PropTypes.bool.isRequired,
  tooltipWidth: PropTypes.number,
  tooltipDurationToShow: PropTypes.number,
  tooltipPosition: PropTypes.oneOf(['left', 'right', 'center']),
  tooltipDirection: PropTypes.oneOf(['up', 'down']),
  tooltipMobileDirection: PropTypes.oneOf(['up', 'down']),
  'data-test': PropTypes.string,
  placement: PropTypes.string
});

_defineProperty(Button, "defaultProps", {
  showMessage: false,
  messageData: ['Added to wishlist', 'Add to wishlist'],
  tooltipWidth: 256,
  tooltipDurationToShow: 0,
  tooltipPosition: 'left',
  tooltipDirection: 'down',
  onUpdate: function onUpdate() {},
  onChange: function onChange() {},
  'data-test': 'component-atw',
  placement: null
});

export function isInWishlist(state, props) {
  var _state$userDetails, _state$userDetails$da;

  var list = (state === null || state === void 0 ? void 0 : (_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : (_state$userDetails$da = _state$userDetails.data) === null || _state$userDetails$da === void 0 ? void 0 : _state$userDetails$da.userState) === 'LOGGEDIN' ? state.globalList : state.localList;
  var _list$data = list.data,
      data = _list$data === void 0 ? {} : _list$data;
  var _data$wishlists = data.wishlists,
      wishlists = _data$wishlists === void 0 ? [] : _data$wishlists;

  var _ref = wishlists.length && wishlists[0] || {},
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items;

  var byPartNumber = function byPartNumber(_ref2) {
    var partNumber = _ref2.partNumber,
        deleted = _ref2.deleted;
    return partNumber === props.item.partNumber && !deleted;
  };

  var inWishlist = items.find(byPartNumber) || false;
  return inWishlist;
}

function mapStateToProps(state, props) {
  var _state$userDetails2, _state$userDetails2$d;

  var isChecked = isInWishlist(state, props);
  var userState = state === null || state === void 0 ? void 0 : (_state$userDetails2 = state.userDetails) === null || _state$userDetails2 === void 0 ? void 0 : (_state$userDetails2$d = _state$userDetails2.data) === null || _state$userDetails2$d === void 0 ? void 0 : _state$userDetails2$d.userState;
  var localListSize = state.localList.data.wishlists[0].items.length;
  var globalError = !!state.globalList.error;
  return {
    isChecked: isChecked,
    userState: userState,
    localListSize: localListSize,
    globalError: globalError
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addLocalItems: addLocalItems,
    removeLocalItems: removeLocalItems,
    addGlobalItems: addGlobalItems,
    removeGlobalItems: removeGlobalItems
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Button);